<div class='admissions-accelerators-tab1-part'>
	<acc-offered-seat-counts-part></acc-offered-seat-counts-part>
</div>